import React from "react";

const StarRating = ({ rating = 0, max = 5, size = 24, color = "#FFD700" }) => {
    const stars = [];

    for (let i = 1; i <= max; i++) {
        const full = rating >= i;
        const half = !full && rating + 0.5 >= i;
        stars.push(
            <span key={i} style={{ fontSize: size, color }}>
                {full ? "★" : half ? "⯨" : "☆"}
            </span>
        );
    }

    return <div style={{ display: "inline-flex", alignItems: "center" }}>{stars}</div>;
};

export default StarRating;
